import { useQuery } from '@apollo/client';
import {
  fetchRefundDetailQuery,
  RefundDetail,
  getRefundIcon,
  getRefundSubheader,
} from '../../../account-subscriptions/billing';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Refund } from '@atlassian/cssxp-types-billing';
import { PageHeader, ErrorComponents } from '../..';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { withApollo } from '../../graphql-provider';
interface Props {
  refundId: string;
}

export const RefundPreview = React.memo(({ refundId }: Props) => {
  const { data, loading, error } = useQuery<
    generatedTypesNew.FetchRefundDetailQueryQuery,
    generatedTypesNew.FetchRefundDetailQueryQueryVariables
  >(fetchRefundDetailQuery, {
    variables: {
      id: refundId,
    },
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorComponents.GenericErrorPage error={error} />;
  }

  const refund = (data?.refund ? data.refund[0] : null) as Refund;
  if (!refund) {
    return (
      <ErrorComponents.ErrorPanel
        error={new ErrorComponents.NotFoundError(`Unable to find refund with ID: ${refundId}`)}
      />
    );
  }

  if (!refund.refundItems) {
    return null;
  }

  const { id } = refund;

  return (
    <div className="full-entity billing-document">
      <PageHeader
        icon={getRefundIcon()}
        header={<Link to={`/refunds/${encodeURIComponent(id)}`}>{id}</Link>}
        subheader={getRefundSubheader(refund)}
      />
      <RefundDetail refund={refund} />
    </div>
  );
});

export default withApollo(RefundPreview);
